export default __webpack_public_path__ + "static/media/Figure-outside-body-walking.262688dc.png";